import type { DocMigration } from "../docMigration";

const DataSequenceDocEntityPrefix = "dataSequence";

function dataSequenceHandleHash(dataSequenceId: string) {
  return `${DataSequenceDocEntityPrefix}.${dataSequenceId}`;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_455: DocMigration = {
  maxSchemaVersion: "0.0.455",
  description: "Remove disabled values for any data sequence groups",
  apply(json: any) {
    if (!Object.keys(json.groups ?? {}).length) {
      return json;
    }

    for (const id in json.dataSequences ?? {}) {
      const hash = dataSequenceHandleHash(id);
      const groupId = json.entityGroups[hash];

      if (!groupId) {
        continue;
      }

      const group = json.groups[groupId];

      if (!group) {
        continue;
      }

      if ("disabled" in group && group.disabled !== undefined) {
        delete group.disabled;
      }
    }

    return json;
  },
};

export default migration_0_0_455;
